import { render, staticRenderFns } from "./VideoProgress.vue?vue&type=template&id=cdaf5a3c&scoped=true&"
import script from "./VideoProgress.vue?vue&type=script&lang=js&"
export * from "./VideoProgress.vue?vue&type=script&lang=js&"
import style0 from "./VideoProgress.vue?vue&type=style&index=0&id=cdaf5a3c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdaf5a3c",
  null
  
)

export default component.exports